module.exports = __webpack_public_path__ + "static/media/jm.5e90dbbb.svg";